import { render, staticRenderFns } from "./KnFormIncome.vue?vue&type=template&id=7cfa2eec&"
import script from "./KnFormIncome.vue?vue&type=script&lang=js&"
export * from "./KnFormIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports